import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StepsComponent } from './steps.component';
import { StepsRoutingModule } from './steps-routing.module';

import { CatalogueModule } from './../../component/catalogue/catalogue.module';
import { DemoModule } from './../../component/demo/demo.module';
import { CodeModule } from './../../component/code/code.module';

import {StepsModule} from "../../component/ing/steps/steps";
import {TableModule} from "../../component/ing/table/table";
import {GrowlModule} from "../../component/ing/growl/growl";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    StepsRoutingModule,
    CatalogueModule,
    DemoModule,
    CodeModule,
    TableModule,
    StepsModule,
    GrowlModule
  ],
  declarations: [StepsComponent]
})
export class StepsDemoModule { }



// WEBPACK FOOTER //
// ./src/app/view/steps/stepsDemo.module.ts